import { fetchTransferDownloadLink } from '../api/transfer';
import { TRANSFER_STATES } from '@wetransfer/transfer/transfer-bundle/constant/transfer-states';

function validateData({ transfer, secret, fileIds }) {
  if (!transfer.id) {
    throw new Error('InvalidTransfer');
  }

  if (
    transfer.state !== TRANSFER_STATES.DOWNLOADABLE &&
    transfer.state !== TRANSFER_STATES.DOWNLOADING &&
    transfer.state !== TRANSFER_STATES.FINISHED
  ) {
    throw new Error('TransferNotDownloadable');
  }

  if (!secret) {
    throw new Error('MissingSecret');
  }

  if (
    fileIds &&
    !fileIds.every((fileId) => transfer.items.find(({ id }) => id === fileId))
  ) {
    throw new Error('InvalidTransfer');
  }
}

function executeDownload({ downloadLink, uploadInProgress }) {
  if (!downloadLink) {
    throw new Error('DownloadFailed');
  }

  if (uploadInProgress) {
    const link = window.open(downloadLink.direct_link);

    if (link) {
      link.opener = null;
    }

    return link;
  }

  return document.location.assign(downloadLink.direct_link);
}

/*
  Download intent specifies whether the user wants just a single file or the entire transfer.
  In some situations we allow a transfer to download as a single file "bare" instead of downloading it as a ZIP,
  but we need to be sure this is what the user actually wants. For example, when a transfer contains only one
  file - but that file is in a folder - if the user explicitly requests download for the entire transfer we
  still must wrap it in a ZIP
*/
const DOWNLOAD_INTENT_ENTIRE_TRANSFER = 'entire_transfer';
const DOWNLOAD_INTENT_SINGLE_FILE = 'single_file';

async function download({
  transfer,
  secret,
  recipientId,
  fileIds,
  domainUserId,
  uploadInProgress,
  intent,
}) {
  validateData({ transfer, secret, fileIds });

  const downloadLink = await fetchTransferDownloadLink({
    transferId: transfer.id,
    secret,
    recipientId,
    fileIds,
    password: transfer.password,
    domainUserId,
    intent,
  });

  executeDownload({ downloadLink, uploadInProgress });
}

export {
  download,
  DOWNLOAD_INTENT_SINGLE_FILE,
  DOWNLOAD_INTENT_ENTIRE_TRANSFER,
};
